/** 桔子权益相关接口 */
import requestDefault from '@/shared/utils/request';
import { RightsBannerType } from '@/views_v2/my-profile/types';
import { packageTypeEnum } from './types';

/** f.package.channel.order.info(根据渠道信息查询最近一笔订单存在)
 * https://yapi.hellobike.cn/project/6149/interface/api/277533
 */
export const hasPackageOrder = (
  supplierCode: string,
): Promise<boolean> => requestDefault.postGate<boolean>(
  'f.package.channel.order.info',
  {
    supplierCode,
  },
);


/** f.package.channel.property.query(外部权益包查询)
 * https://yapi.hellobike.cn/project/6149/interface/api/277530
 * 获取权益外跳链接用
 */
export const getPackageQuery = (params: {
  packageType: packageTypeEnum | string,
  supplierCode: string,
  orderId?: string,
}): Promise<{
  entranceUrl: string;
}> => requestDefault.postGate<{
  entranceUrl: string;
}>(
  'f.package.channel.property.query',
  {
    ...params,
  },
);

/** f.marketing.rights.order.useEntranceList(获取渠道使用订单入口集合)
 * https://yapi.hellobike.cn/project/7020/interface/api/319442
 * 我的页面 权益中心 用户可领取权益列表获取
 */
export const getPackageOrange = (
): Promise<RightsBannerType[]> => requestDefault.postGate<RightsBannerType[]>(
  'f.marketing.rights.order.useEntranceList',
  {},
  {
    showLoading: undefined,
  },
);
